import { Box, Grid } from '@material-ui/core';
import { useFormState, useForm } from 'react-final-form';
import _ from 'lodash';
import { useMemo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

import QCXFinalBondManager from '../../../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';
import QCXFinalTextField from '../../../../shared-components/final-text-field/QCXFinalTextField';
import SelectFundamentosOpcionais from './SelectFundamentosOpcionais';

/*  REGIMES E FUNDAMENTOS II, IPI, PIS/COFINS */

import { selectRegimesTributacao } from '../../../../features/regime-tributacao/regimeTributacaoSlice';

import {
  fetchAllAsync as fetchAllAsyncIi,
  selectFundamentosLegaisRegimeTributacaoIi,
} from '../../../../features/fundamento-legal-regime-tributacao-ii/fundamentoLegalRegimeTributacaoIiSlice';

import { selectRegimesTributacaoIpi } from '../../../../features/regime-tributacao-fundamento-legal-ipi/regimeTributacaoIpiSlice';

import {
  fetchAllAsync as fetchAllAsyncPisCofins,
  selectFundamentosLegaisPisCofins,
} from '../../../../features/fundamento-legal-pis-cofins/fundamentoLegalPisCofinsSlice';

export default function QCXSelectManyFundamentosOpcionais({
  listFundamentos = [],
  name = '',
  values = {},
  disabled = false,
  fundamentosOpcionaisGrouped = [],
  ...restProps
}) {
  const dispatch = useDispatch();
  const form = useForm();
  const [idAdicao, setIdAdicao] = useState(null);

  /* REGIMES II, IPI, PIS/COFINS */
  const listRegimes = useSelector(selectRegimesTributacao);
  const regimeIntegral = listRegimes?.find((r) => r?.code === '1');

  /* FUNDAMENTOS II, IPI, PIS/COFINS */
  const listFundamentosIi = useSelector(selectFundamentosLegaisRegimeTributacaoIi);
  const listRegimesFundamentosIpi = useSelector(selectRegimesTributacaoIpi);
  const listFundamentosPisCofins = useSelector(selectFundamentosLegaisPisCofins);

  useEffect(() => {
    dispatch(fetchAllAsyncPisCofins());
    dispatch(fetchAllAsyncIi(true));
  }, []);

  const [listFundamentosIpi, setListFundamentosIpi] = useState([]);

  const findItemArrayByCode = (code, arraySearch, label) => {
    if (!arraySearch || !_.isArray(arraySearch)) return null;
    if (!label) label = 'code';
    return arraySearch.find((item) => item[`${label}`] === code);
  };

  useEffect(() => {
    if (!listRegimesFundamentosIpi || !_.isArray(listRegimesFundamentosIpi)) return [];

    const objFundamentoProcessado = {};
    const fundamentosIpi = [];

    listRegimesFundamentosIpi.forEach((regime) => {
      regime.fundamentosTributarios.forEach((fundamento) => {
        if (!objFundamentoProcessado[fundamento.id]) {
          fundamentosIpi.push(fundamento);
          objFundamentoProcessado[fundamento.id] = true;
        }
      });
    });

    setListFundamentosIpi([...fundamentosIpi]);

    return null;
  }, [listRegimesFundamentosIpi]);

  const atualizaSecoesDeImpostosNoForm = useCallback(
    (listaTratamentos) => {
      const regimeIntegralId = regimeIntegral?.id ?? null;
      const regimeIntegralCode = regimeIntegral?.code ?? null;

      form.change('ii.regimeTributacao.id', regimeIntegralId);
      form.change('ii.regimeTributacao.code', regimeIntegralCode);
      form.change('ii.fundamentoLegalRegimeTributacaoIi.id', null);
      form.change('ipi.regimeTributacao.id', regimeIntegralId);
      form.change('ipi.regimeTributacao.code', regimeIntegralCode);
      form.change('ipi.fundamentoLegalDuimp.id', null);
      form.change('pisCofins.regimeTributacao.id', regimeIntegralId);
      form.change('pisCofins.regimeTributacao.code', regimeIntegralCode);
      form.change('pisCofins.fundamentoLegal.id', null);

      listaTratamentos.forEach((tratamento) => {
        if (tratamento?.tributo?.codigo === '1') {
          // II
          const regimeSelecionado = findItemArrayByCode(tratamento?.regime?.codigo, listRegimes);
          const fundamentoSelecionadoIi = findItemArrayByCode(tratamento?.fundamento?.id, listFundamentosIi);

          if (regimeSelecionado && fundamentoSelecionadoIi) {
            form.change('ii.regimeTributacao.id', regimeSelecionado.id);
            form.change('ii.fundamentoLegalRegimeTributacaoIi.id', fundamentoSelecionadoIi.id);
          }
        } else if (tratamento?.tributo?.codigo === '2') {
          // IPI
          const regimeSelecionado = findItemArrayByCode(tratamento?.regime?.codigo, listRegimes);
          const fundamentoSelecionadoIpi = findItemArrayByCode(
            tratamento?.fundamento?.id,
            listFundamentosIpi,
            'codigoFundamento'
          );

          if (regimeSelecionado && fundamentoSelecionadoIpi) {
            form.change('ipi.regimeTributacao.id', regimeSelecionado.id);
            form.change('ipi.fundamentoLegalDuimp.id', fundamentoSelecionadoIpi.id);
          }
        } else if (tratamento?.tributo?.codigo === '6' || tratamento?.tributo?.codigo === '7') {
          // PIS/COFINS
          const regimeSelecionado = findItemArrayByCode(tratamento?.regime?.codigo, listRegimes);
          const fundamentoSelecionadoPisCofins = findItemArrayByCode(
            tratamento?.fundamento?.id,
            listFundamentosPisCofins
          );

          if (regimeSelecionado && fundamentoSelecionadoPisCofins) {
            form.change('pisCofins.regimeTributacao.id', regimeSelecionado.id);
            form.change('pisCofins.fundamentoLegal.id', fundamentoSelecionadoPisCofins.id);
          }
        }
      });
    },
    [regimeIntegral, listFundamentosIpi, listFundamentosIi, listFundamentosPisCofins, listRegimes]
  );

  useEffect(() => {
    const valoresFundamentosAdicao = form.getState().values?.valoresMetadadoTtce?.valorMetadadosJson?.opcionais;
    const atributoSelecionados = _.get(form.getState().values, name, []);
    const adicaoAtualId = _.get(form.getState().values, 'id', null);

    if (!valoresFundamentosAdicao || Object.keys(valoresFundamentosAdicao).length === 0) return;
    const tratamentosUnnormalized = [];

    Object.entries(valoresFundamentosAdicao).forEach(([key, value]) => {
      const idFundamento = value?.fundamento?.codigo;
      if (!idFundamento) return;

      const fundamentoSelecionado = fundamentosOpcionaisGrouped.find((el) => el.id === idFundamento);

      if (!fundamentoSelecionado) {
        return;
      }

      if (!fundamentoSelecionado?.tratamentos) {
        return;
      }

      const fundamento = {
        id: fundamentoSelecionado.id,
        codigo: fundamentoSelecionado.tipo,
        nome: fundamentoSelecionado.nome,
      };

      const tributoCodigo = value?.tributo?.codigo;
      const regimeCodigo = value?.regime?.codigo;
      const tratamentoMeta = fundamentoSelecionado?.tratamentos?.find(
        (tratamento) => tratamento?.tributo?.codigo === tributoCodigo && tratamento?.regime?.codigo === regimeCodigo
      );

      if (tributoCodigo && regimeCodigo) {
        tratamentosUnnormalized.push({
          id: uuid(),
          codigo: fundamentoSelecionado.id,
          fundamento: { ...fundamento },
          regime: { ...(tratamentoMeta?.regime || value?.regime || {}) },
          tributo: { ...(tratamentoMeta?.tributo || value?.tributo || {}) },
        });
      } else {
        const novosTratamentos = fundamentoSelecionado?.tratamentos.map((tratamento) => ({
          id: uuid(),
          codigo: fundamentoSelecionado.id,
          fundamento: { ...fundamento },
          regime: { ...tratamento.regime },
          tributo: { ...tratamento.tributo },
        }));

        tratamentosUnnormalized.push(...novosTratamentos);
      }
    });

    if (adicaoAtualId !== idAdicao) {
      form.change(name, [...tratamentosUnnormalized]);
      setIdAdicao(adicaoAtualId);
    } else {
      setIdAdicao(adicaoAtualId);
      if (!atributoSelecionados || (_.isArray(atributoSelecionados) && atributoSelecionados.length === 0)) {
        form.change(name, [...tratamentosUnnormalized]);
      } else {
        // tratar caso fazer merge com os tratamentos já existentes
        console.log('===> tratar caso');
      }
    }

    atualizaSecoesDeImpostosNoForm(tratamentosUnnormalized);
  }, [name, fundamentosOpcionaisGrouped, atualizaSecoesDeImpostosNoForm]);

  const tratamentosProps = useMemo(
    () => ({
      name,
      columns: [
        {
          field: 'tributo',
          headerName: 'Tributo',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => `${row?.tributo?.codigo} - ${row?.tributo?.nome}`,
        },
        {
          field: 'regime',
          headerName: 'Regime Tributário',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => `${row?.regime?.codigo} - ${row?.regime?.nome}`,
        },
        {
          field: 'fundamento',
          headerName: 'Fundamento Legal Opcional',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => `${row?.fundamento.id} - ${row?.fundamento.nome}`,
        },
      ],
    }),
    []
  );

  const tratamentosFormProps = useMemo(
    () => ({
      rootName: `ignorableFields.tratamentos`,
      fields: [
        {
          name: 'fundamentoLegalOpcional',
          label: 'Fundamento Legal Opcional',
          required: false,
        },
      ],
    }),
    []
  );

  const handleAlreadyExistsTratamento = useCallback((currentVinculo, currentVinculosList) => {
    if (_.isArray(currentVinculosList)) {
      const vinculoRepetido = currentVinculosList.find((el) => el.codigo === currentVinculo.codigoAtual);
      if (vinculoRepetido) return true;
    }
    return false;
  }, []);

  const handleAddTratamento = useCallback(
    async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
      const idFundamento = _.get(currentVinculo, 'selectFundamentosOpcionaisCode');
      const fundamentoSelecionado = fundamentosOpcionaisGrouped.find((el) => el.id === idFundamento);

      if (!fundamentoSelecionado) {
        return;
      }

      if (!fundamentoSelecionado?.tratamentos) {
        return;
      }

      const fundamento = {
        id: fundamentoSelecionado.id,
        codigo: fundamentoSelecionado.tipo,
        nome: fundamentoSelecionado.nome,
      };

      const novosTratamentos = fundamentoSelecionado?.tratamentos.map((tratamento) => ({
        id: uuid(),
        codigo: fundamentoSelecionado.id,
        fundamento: { ...fundamento },
        regime: { ...tratamento.regime },
        tributo: { ...tratamento.tributo },
      }));

      let todosTratamentos = [...novosTratamentos];
      if (_.isArray(currentVinculos)) todosTratamentos = [...currentVinculos, ...novosTratamentos];

      form.change(name, todosTratamentos);
      form.change('ignorableFields.tratamentos.selectFundamentosOpcionaisCode', null);

      atualizaSecoesDeImpostosNoForm(todosTratamentos);
    },
    [values]
  );

  const handleRemoveTratamento = useCallback(
    async ({ target, list }) => {
      /*
        necessario remover todos os fundamentos da lista, por isso nao basta remover apenas o id do elemento clicado.
      */

      const { id } = target;
      const tratamentoRemove = list.find((el) => el.id === id);

      if (!tratamentoRemove) {
        console.log(`Tratamento com id ${id} não encontrado.`);
        return;
      }

      const codigoFundamento = tratamentoRemove?.fundamento?.id;

      if (!codigoFundamento) {
        console.log(`Tratamento com id ${id} não possui um código de fundamento válido.`);
        return;
      }

      const novaLista = list.filter((el) => el.id !== id);

      form.change(name, [...novaLista]);

      atualizaSecoesDeImpostosNoForm(novaLista);
    },
    [values]
  );

  const handleUpdateTratamento = useCallback(
    async (currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
      if (!currentVinculo?.id) {
        return;
      }
      if (!_.isArray(currentVinculos)) {
        return;
      }

      const { id } = currentVinculo;
      const vinculos = [...currentVinculos];
      const index = vinculos.findIndex((el) => el.id === id);

      if (index === -1) {
        return;
      }

      vinculos[index].codigo = currentVinculo.codigoAtual;
      form.change('codigos', [...vinculos]);

      form.change('ignorableFields.codigoAtual', null);
    },
    [values]
  );

  return (
    <>
      <QCXFinalBondManager
        isParentConsult={disabled}
        listProps={tratamentosProps}
        formProps={tratamentosFormProps}
        handleAdd={handleAddTratamento}
        handleRemove={handleRemoveTratamento}
        handleUpdate={handleUpdateTratamento}
        handleAlreadyExists={handleAlreadyExistsTratamento}
        disableDefaultRemove
        forceShowDelete
        controlButtonsGridProps={{
          add: {
            xs: 2,
            sm: 2,
            md: 2,
          },
        }}
      >
        <Grid item xs={12} sm={12} md={7} lg={7}>
          <SelectFundamentosOpcionais
            listFundamentos={fundamentosOpcionaisGrouped}
            name="ignorableFields.tratamentos.selectFundamentosOpcionaisCode"
            values={values}
            disabled={disabled}
          />
        </Grid>
      </QCXFinalBondManager>
    </>
  );
}
